// extracted by mini-css-extract-plugin
export default {"root":"InventoryManagement_root__ehVz-","enableDisable":"InventoryManagement_enableDisable__66i+K","label":"InventoryManagement_label__oqyUg"};